
import { GraphQLError } from './GraphQLError';

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

export function syntaxError(source, position, description) {
  return new GraphQLError('Syntax Error: ' + description, undefined, source, [position]);
}


//////////////////
// WEBPACK FOOTER
// ../~/graphql/module/error/syntaxError.js
// module id = 784
// module chunks = 0